import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyle = makeStyles(theme => ({
  duplicateDialog: {
    width: 450,
    height: 260,
  },
  autoFixDialog: {
    maxWidth: 500,
    minHeight: 250,
  },
}));

export default useStyle;
